import { StatePersistenceService } from "@services/state-persistence.service";
import { TokenUtils } from "@utils/token.utils";

import { computed, effect, inject, Service, signal } from "@angular/core";

export interface UserStateModel {
  rut: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  tenants: { tenantName: string; isAdmin: boolean }[];
  isPlatformAdministrator: boolean;
}

const DEFAULT_STATE: UserStateModel = {
  rut: "",
  email: "",
  firstName: "",
  lastName: "",
  fullName: "",
  tenants: [],
  isPlatformAdministrator: false,
};

@Service()
export class UserStore {
  private readonly persistence = inject(StatePersistenceService);
  private state = signal(
    this.persistence.read<UserStateModel | null>("User", DEFAULT_STATE)
  );

  rut = computed(() => this.state()?.rut ?? "");
  email = computed(() => this.state()?.email ?? "");
  firstName = computed(() => this.state()?.firstName ?? "");
  lastName = computed(() => this.state()?.lastName ?? "");
  fullName = computed(() => this.state()?.fullName ?? "");
  tenants = computed(() => this.state()?.tenants ?? []);
  isPlatformAdministrator = computed(
    () => this.state()?.isPlatformAdministrator ?? false
  );

  constructor() {
    effect(() => this.persistence.write("User", this.state()));
  }

  setUser(accessToken: string) {
    const tokenUtils = new TokenUtils(accessToken);
    this.state.set({
      rut: tokenUtils.getUserRut(),
      email: tokenUtils.getUserEmail(),
      firstName: tokenUtils.getUserFirstName(),
      lastName: tokenUtils.getUserLastName(),
      fullName: tokenUtils.getUserFullName(),
      tenants: (tokenUtils.getUserTenants() ?? []).map(tenant => ({
        tenantName: tenant.replace("/", ""),
        isAdmin: tokenUtils.getUserAdmin().includes(tenant.replace("/", "")),
      })),
      isPlatformAdministrator: tokenUtils.isPlatformAdministrator(),
    });
  }

  clearUser() {
    this.state.set(null);
  }
}
